import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/services/authentication.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as feather from 'feather-icons';
import { commonComponents } from '@app/shared/common components/common components';

@Component({
  standalone: false,
  selector: 'app-assessment-order',
  templateUrl: './assessment-order.component.html',
  styleUrls: ['./assessment-order.component.css'],
})
export class AssessmentOrderComponent implements OnInit {
  error: string;
  data: any[] = [];
  paginatedData: any[] = [];
  isLoading = false;
  currentPage = 1;
  pageSize = 25;
  totalItems = 0;
  totalPages = 0;
  searchTerm = '';
  headers = commonComponents.BackgroundCheck.headers 
  sortField: string;
  sortDirection: number;
  enable = false
  constructor(private _authentication: AuthenticationService, private _router: Router) {}
  ngOnInit() {
    this.loadData();
  }
  ngAfterViewInit() {
    feather.replace();
  }
  loadData() {
    this.isLoading = true;
    this._authentication
      .assessmentOrderService(this.enable)
      .pipe(
        catchError((error) => {
          this.error = 'Failed to fetch data. Please try again later.';
          this.isLoading = false;
          return throwError(error);
        }),
      )
      .subscribe(
        (response: any) => {
          this.data = response.data;
          this.totalItems = this.data.length;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.sortData();
          this.filterData();
          this.isLoading = false;
        },
        () => {
          this.error = 'Failed to fetch data. Please try again later.';
          this.isLoading = false;
        },
      );
  }
  sortData() {
    this.data.sort((a, b) => a.id - b.id);
  }
  filterData() {
    const lowerCaseSearchTerm = this.searchTerm.trim().toLowerCase();
  const filteredData = this.data.filter((item) => {
    const payload = item.payload || {};
    const candidate = payload.candidate || {};
      const fullName = `${candidate.firstName || ''} ${candidate.lastName || ''}`.toLowerCase();
    const email = candidate.email || '';

      return (
        item.id.toString().includes(lowerCaseSearchTerm) ||
        fullName.includes(lowerCaseSearchTerm) ||
        email.includes(lowerCaseSearchTerm)
      );
    });
    this.totalItems = filteredData.length;
    this.totalPages = Math.ceil(this.totalItems / this.pageSize); 
    this.paginatedData = filteredData.slice(
      (this.currentPage - 1) * this.pageSize,
      this.currentPage * this.pageSize
    );
  }
  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.filterData();
    }
  }
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.filterData();
    }
  }
  goToFirstPage(): void {
    this.currentPage = 1;
    this.filterData();
  }

  goToLastPage(): void {
    this.currentPage = this.totalPages;
    this.filterData();
  }
  
  changeSort(field: string): void {
    if (this.sortField === field) {
      this.sortDirection = -this.sortDirection;
    } else {
      this.sortField = field;
      this.sortDirection = 1;
    }
    this.sortCandidates();
  }
  sortCandidates() {
    this.paginatedData.sort((a, b) => {
      const aValue = this.getValueByField(a, this.sortField);
      const bValue = this.getValueByField(b, this.sortField);

      if (aValue < bValue) return -this.sortDirection;
      if (aValue > bValue) return this.sortDirection;
      return 0;
    });
  }
  getValueByField(item: any, field: string): any {
    if (field === 'name') {
            const payload = item.payload || {};
      const candidate = payload.candidate || {};
      return `${candidate.firstName || ''} ${candidate.lastName || ''}`.toLowerCase();
    }
    if (field === 'email') {
      const payload = item.payload || {};
      const candidate = payload.candidate || {};
      return (candidate.email || '').toLowerCase();
    }
    const keys = field.split('.'); 
    let value = item;
    keys.forEach(key => {
      value = value[key];
    });
    return value;
  }
  onSearchChange() {
    this.currentPage = 1;
    this.filterData();
  }
  onInvestigate(item: any) {
    const matrixParams = {
      name: String(
        `${
          (item.payload.candidate ? item.payload.candidate.firstName : '') +
          ' ' +
          (item.payload.candidate ? item.payload.candidate.lastName : '')
        }`,
      ),
      recordId: item.id,
    };
    this._router.navigate(['/home/assessment-investigation', { ...matrixParams }]);
  }
  isEnable(){
    this.enable = !this.enable
    this.loadData()
  }
}
